module.exports = {
      id: "read-more-arrow-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "svg-sprite.svg#read-more-arrow",
      toString: function () {
        return this.url;
      }
    }